import React from "react"

const Logo = () => {
    return (
        <img className='inline-block' src={'/Images/logo.png'} alt='' width='160px' height='35px' />
    )
}

export default Logo